import { useCallback, useEffect, useRef, useState } from 'react';
const STEP_MS = 100;
export const useVideoProgress = (param)=>{
    let { durationMs, onComplete } = param;
    const [progress, setProgress] = useState(0);
    const intervalRef = useRef(null);
    const onCompleteRef = useRef(onComplete);
    onCompleteRef.current = onComplete;
    const start = useCallback(()=>{
        if (intervalRef.current) return;
        const increment = STEP_MS / durationMs * 100;
        intervalRef.current = setInterval(()=>{
            setProgress((prev)=>{
                const next = prev + increment;
                if (next >= 100) {
                    if (intervalRef.current) {
                        clearInterval(intervalRef.current);
                        intervalRef.current = null;
                    }
                    setTimeout(()=>onCompleteRef.current(), 200);
                    return 100;
                }
                return next;
            });
        }, STEP_MS);
    }, [
        durationMs
    ]);
    const pause = useCallback(()=>{
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    const reset = useCallback(()=>{
        pause();
        setProgress(0);
    }, [
        pause
    ]);
    useEffect(()=>()=>pause(), [
        pause
    ]);
    return {
        progress,
        start,
        pause,
        reset
    };
};
